/**
 * Constants used For Error handling Scenarios.
 */

const apiErrors = (() => {
    return {
        100: 'Something went wrong!',
        400: 'Bad Request',
        401: 'Invalid Password',
        403: 'Invalid Access. Send valid authorizarion token.Either token is invalid or its expired',
        404: 'Resource Not Found',
        405: 'Emulate User on the same role is not allowed',
        502: 'Something went wrong with background server!',
        800: 'Invalid email',
        801: 'Authorization unsuccessful.Eiher email/mobile or password is invalid',
        802: 'Your account is currently inactive',
        803: 'Invalid OTP',
        804: 'Invalid Mobile',
        805: 'Gst number (GSTIN) should be 15 characters only',
        807: 'Invalid UserId',
        1000: 'Request flight is not longer available.Please try different flight',// Flight Errors 1000-1999
        1001: 'Infant can\'t be greater than no of adults.',
        1002: 'Child can\'t be greater than no of adults.',
        1003: 'Travel date should be in ascending order . Next travel date can\'t be less than previous travel date.',
        1004: 'Travel date can\'t be after year.',
        1005: 'Origin and Destination can\'t be same.',
        1006: 'No of passenger can\'t be greater than 9.',
        1007: 'First Name shouldn\'t be blank and it shouldn\'t contains any whitespace character.',
        1008: 'Last Name shouldn\'t be blank and it should contains only alphabet and  whitespace character.',
        1009: 'Total length of the name shouldn\'t be more than 50 characters',
        1010: 'Any two passengers can\'t have same name',
        1012: 'Adult\'s age should be greater than 12 years from  the date of departure.',
        1013: 'Child\'s age should be between 2 -12 years from the date of departure.',
        1014: 'Infants age should be between 0 -2 years from the date of departure.',
        1015: 'Total amount passed in payment doesn\'t match with total order Amount',
        1016: 'No booking found with mentioned pnr',
        1017: 'No Valid Supplier Found',
        2000: 'Unable to connect to database',
        2001: 'Insufficient Balance',
        2002: 'Refund can\'t exceed amount charge',
        2501: 'No order found with given orderId',
        2502: 'There is already an order exist with given bookingId, Please use new bookingId and then try',
        2503: 'BookingId passed in the request is already expired,Kindly generate newbookingId from review response',
        2504: 'Invalid request, data passed is wrong',
        2700: 'Only Admin/Accounts can create/update CreditLine Information!',
        4000: 'Invalid Rule',
        4001: 'Rule can\'t be null',
        4002: 'Invalid Product',
        4003: 'Invalid Code',
        4004: 'Commercial Criteria can\'t be null',
        4005: 'commercialCriteria.components can\'t be null',
        4006: 'Invalid component.type',
        4007: 'component.thresholdAmount (ta) can\'t be null',
        4008: 'component.expression (exp) can\'t be null',
        4009: 'Invalid expression',
        4010: 'Invalid airline code',
        4011: 'Invalid pax-type',
        4012: 'Invalid supplier id',
        4013: 'Invalid user id',
        4014: 'Invalid source id',
        4015: 'Invalid cabin class',
        4016: 'Invalid route',
        4017: 'Invalid travel period',
        4018: 'Invalid booking period',
        4019: 'Invalid Plan id',
        4020: 'Plan Already Exist',
        4021: 'Plan name can`t be empty',
        2505: 'Previous amendment in progress',
        2710: 'Not Updatable.'
    };
})();

export default apiErrors;
